import { useEffect, useState } from 'react';
import { capturePostHogEvent, getPostHogClient } from '../utils/analytics';
import {
  WebsiteThemeExperimentController,
  WebsiteThemeFlagClient,
} from './WebsiteThemeExperimentController';

export function isWebsiteThemePreview(pathname: string, search: string): boolean {
  return (
    /(?:^|\/)(?:challenges-clarity|courses-clarity|demo|review)(?:\/|$)/.test(pathname) ||
    Array.from(new URLSearchParams(search).keys()).some((key) =>
      /variant|design|theme|preview|experiment/i.test(key),
    )
  );
}

export function WebsiteThemeExperiments({
  pathname,
  search,
  authLoading,
  isAuthenticated,
  email,
}: {
  pathname: string;
  search: string;
  authLoading: boolean;
  isAuthenticated: boolean;
  email?: string;
}) {
  const [client, setClient] = useState<WebsiteThemeFlagClient | null>(null);
  useEffect(() => {
    const candidate = getPostHogClient({ initialize: true });
    if (candidate) {
      setClient(candidate);
    }
  }, []);
  return (
    <WebsiteThemeExperimentController
      client={client}
      pathname={pathname}
      capture={capturePostHogEvent}
      enrollmentExcluded={authLoading || isAuthenticated}
      excluded={
        isWebsiteThemePreview(pathname, search) ||
        /@(?:lumiwealth\.com|botspot\.trade)$/i.test(email || '')
      }
    />
  );
}
